import type { DeleteReportResponsePayload } from '@vy/api-definition';
import { DeleteReportResponseSchema } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type DeleteReportRequest = Parameters<WeftApi['deleteReport']>[0];

export function useDeleteReport(
  options?: UseMutationOptions<DeleteReportResponsePayload, unknown, DeleteReportRequest>,
) {
  return useMutation({
    mutationFn: async ({ reportId }) => {
      const api = getPrivateApi();
      const deleteReportResponse = await api.deleteReport({ reportId });

      return DeleteReportResponseSchema.parse(deleteReportResponse);
    },
    ...options,
  });
}
